export default "__VITE_ASSET__BN5OP31L__"